import {Component, Input, OnInit} from '@angular/core';
import {TicketElement} from '../../../../../../projects/shared-lib/src/lib/models/ticket-element';
import * as PDFObject from '../../../../../../lib/PDFObject';
import { ClientTicketDetailComponent } from '../client-ticket-detail/client-ticket-detail.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tw-client-tickets-summary',
    templateUrl: './client-tickets-summary.component.html',
    styleUrls: ['./client-tickets-summary.component.css'],
    imports: [ClientTicketDetailComponent, MatIconButton, MatIcon, TranslatePipe]
})
export class ClientTicketsSummaryComponent implements OnInit {

    @Input() ticketElements: TicketElement[];
    displayPdf = false;

    constructor() {
    }

    ngOnInit() {
    }

    displayPdfFile(url) {
        this.displayPdf = true;
        setTimeout(() => {
            PDFObject.embed(url, '#pdf-output');
        }, 200);
    }

    hidePdf() {
        this.displayPdf = false;
    }

}
